module.exports = __webpack_public_path__ + "media/app_search/FreeTrialExtend/images/docs--indexing-documents-cea7561cff50884beb9afdd91bfb291d.jpg";